import { render, staticRenderFns } from "./IconTitleItem.vue?vue&type=template&id=71e76162&scoped=true&"
import script from "./IconTitleItem.vue?vue&type=script&lang=js&"
export * from "./IconTitleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e76162",
  null
  
)

export default component.exports